/*
 * @LastEditors: wei ze min
 */
import Http from './../http';
export default {
  // 日历哪天有记录
  getWhetherFeed(urlParams, params, callback, callback1) {
    Http.post('/feedDiary/whetherFeed', urlParams, params, (res) => {
      callback(res);
    },
    (res) => {
      callback1(res);
    });
  },
  // 查询喂养记录正序排列
  getFindFeedDiaryAsc(urlParams, params, callback) {
    Http.post('/feedDiary/findFeedDiaryAsc', urlParams, params, (res) => {
      callback(res);
    });
  },
  // 查询喂养记录倒序排列
  getfindFeedDiaryDesc(urlParams, params, callback) {
    Http.post('/feedDiary/findFeedDiaryDesc', urlParams, params, (res) => {
      callback(res);
    });
  },
  // 添加喂养记录
  addFeedDiary(urlParams, params, callback, callback1) {
    Http.post(
      '/feedDiary/addFeedDiary',
      urlParams,
      params,
      (res) => {
        callback(res);
      },
      (res) => {
        callback1(res);
      }
    );
  },

  // 删除喂养记录
  deleteFeedDiary(params, callback, callback1) {
    Http.get(
      '/feedDiary/deleteFeedDiary',
      params,
      (res) => {
        callback(res);
      },
      (res) => {
        callback1(res);
      }
    );
  },

  // 查询辅食
  getfindSupplement(params, callback) {
    Http.get('/supplement/findSupplement', params, (res) => {
      callback(res);
    });
  },
  // 保存辅食
  saveSupplement(urlParams, params, callback) {
    Http.post('/supplement/saveSupplement', urlParams, params, (res) => {
      callback(res);
    });
  },
  // 删除辅食
  deleteSupplement(urlParams, params, callback) {
    Http.post('/supplement/deleteSupplement', urlParams, params, (res) => {
      callback(res);
    });
  }
};
